import { AdditionalFieldDelegateProps } from "@firecms/core";
import { Chip } from "@firecms/ui";

import { AppleGrantStatusEntity, friendlyGrantStatus } from "./apple_grant_status.types";

// Chip colours keyed by the status a human reads, not by the raw enum — `needsReview` has no state
// of its own but is the most important thing in the list. Keys are FireCMS ChipColorKey values, same
// as `AppleStatusChip`.
const STATUS_COLOR: Record<string, string> = {
  Linked: "greenDark",
  "Needs review": "orangeDark",
  "Not linked": "grayLight",
  Unknown: "grayLight",
};

/** Table-cell renderer: the client's Apple link status as a friendly, coloured chip. */
export function AppleGrantStatusChip({
  entity,
}: AdditionalFieldDelegateProps<Partial<AppleGrantStatusEntity>>) {
  const status = friendlyGrantStatus(entity.values);
  const conflictCount = entity.values.activeCompanyCount;
  return (
    <Chip colorScheme={STATUS_COLOR[status] ?? "grayLight"} size="small">
      {entity.values.needsReview && conflictCount && conflictCount > 1
        ? `${status} — ${conflictCount} companies`
        : status}
    </Chip>
  );
}
